// extracted by mini-css-extract-plugin
module.exports = {"container":"CarrouselMuni_container__2sIhM","content":"CarrouselMuni_content__h7nq0","card":"CarrouselMuni_card__-WMiw","logos":"CarrouselMuni_logos__2-KQI"};